import { Injectable } from '@angular/core';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getOrgAndLocation(): { organizationId: string; locationId: string } {
    const organizationId = this.get(LocalStorageEnum.organization_id) || '';
    const locationId = this.get(LocalStorageEnum.location_id) || '';
    return { organizationId, locationId };
  }

  getOrgId(): string | null {
    const orgId = this.get(LocalStorageEnum.organization_id);
    return orgId;
  }

  setOrgId(orgId: string) {
    this.set(LocalStorageEnum.organization_id, orgId);
  }

  getLocationId(): string | null {
    const locationId = this.get(LocalStorageEnum.location_id);
    return locationId;
  }

  setLocation(locationId: string) {
    this.set(LocalStorageEnum.location_id, locationId);
  }

  get(key: LocalStorageEnum): string {
    const prefix = btoa(key).replace(/=/g, '');
    const item = localStorage.getItem(key);
    if (!item) {
      return '';
    }
    try {
      const base64 = atob(item).replace(prefix, '');
      return atob(base64);
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  set(key: LocalStorageEnum, value: string) {
    const prefix = btoa(key).replace(/=/g, '');
    const base64 = btoa(value);
    localStorage.setItem(key, btoa(prefix + base64));
  }

  setArray(key: LocalStorageEnum, values: any[]) {
    const value = values.toString();
    this.set(key, value);
  }

  getArray(key: LocalStorageEnum): any[] {
    const value = this.get(key);
    return value ? value.split(',') : [];
  }

  delete(key: LocalStorageEnum) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
